import { useQuery } from 'react-query'
import { t } from 'ttag'
import { useSelector } from 'react-redux'
import { useContext } from 'react'

import { api } from '@h2/api'
import { Page } from '@h2/common/components/page'
import { user as getUser } from '@h2/common/selectors/user'
import { Globals } from '@h2/globals'

import { AssignmentOverview } from './components/assignment'
import { LocalOpportunitiesOverview } from './components/localOpportunities'
import { UsersOverview } from './components/users'
import { LinkGeneratorBox } from './components/linkGeneratorBox'
import { MediaKitBox } from './components/mediaKitBox'
import { StyledPage, LinksRow, OverviewRow } from './components/page'

import { Account } from '../account'
import { Feed } from '../feed'

const Navigator = () => {
  const user = useSelector(getUser)
  const { isSubscriber, hasLocalOpportunities, isNavianceElementary } =
    useContext(Globals)
  const { data: apiData, isFetching } = useQuery('dashboard', () =>
    api.fetch('/navigator/dashboard', { method: 'POST' })
  )
  const firstName = user?.firstName
  const ownerName = firstName ? `${firstName}'s ` : ''

  return (
    <StyledPage>
      <Page.Title>{t`${ownerName}Navigator Dashboard`}</Page.Title>
      <Page.Layout className="Navigator-Dashboard-Layout">
        <Page.Content>
          <Account className="Navigator-Dashboard-Account" />
          <OverviewRow justifyContent="space-between" wrap="wrap">
            <AssignmentOverview dashboard={apiData} isFetching={isFetching} />
            {hasLocalOpportunities && (
              <LocalOpportunitiesOverview dashboard={apiData} isFetching={isFetching} />
            )}
          </OverviewRow>
          <UsersOverview
            dashboard={apiData}
            isFetching={isFetching}
            isSubscriber={isSubscriber}
          />
          {!isNavianceElementary && (
            <LinksRow>
              <LinkGeneratorBox />
              <MediaKitBox />
            </LinksRow>
          )}
        </Page.Content>
        <Page.Sidebar className="Navigator-Dashboard-SideBar">
          <Account />
          <Feed />
        </Page.Sidebar>
      </Page.Layout>
    </StyledPage>
  )
}

export { Navigator }
